export class AppSettings {
    static readonly Url = "/"
}